import { CivilStates } from "../../../graphql/generated/types";

export const CivilStateLabels = {
  [CivilStates.Single]: "Solteiro(a)",
  [CivilStates.Married]: "Casado(a)",
  [CivilStates.Divorced]: "Divorciado(a)",
  [CivilStates.Widowed]: "Viúvo(a)",
  [CivilStates.Other]: "Outro",
};
